import { render, staticRenderFns } from "./PageTemplateModalForm.vue?vue&type=template&id=3aeca74c"
import script from "./PageTemplateModalForm.vue?vue&type=script&lang=js"
export * from "./PageTemplateModalForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports